import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Panel from '../../../UniformComponents/Panel'
import Store from './store'
import DataTable from '../../DataTable'
import Select from '../../form/Select'
import Button from '../../../UniformComponents/Button'
import LicenceGroup from './modals/LicenceGroup'
import LicenceAllocation from './modals/LicenceAllocation'

import './style.scss'

@observer
class LicenceManager extends Component {
    constructor(props) {
        super(props)
        this.store = new Store(props.appStore)
    }

    componentDidMount() {
        this.store.init()
    }

    renderTabs = () => (
        <div className="search-panel-right">
            <div className="switch-button">
                <ul className="tabs">
                    {this.store.tabs.map(({ key, onClick, label }) => (
                        <li key={key}>
                            <Button
                                type="button"
                                onClick={onClick}
                                cssClass={`${this.store.tabIsActive(key) ? 'active' : ''}`}
                            >
                                <i className={`fa-regular 'fa-square-poll-vertical'`} />
                                {label}
                            </Button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )

    render() {
        const { store } = this

        return (
            <>
                <LicenceGroup show={store.modals.licenceGroup} store={store} />
                <LicenceAllocation show={store.modals.licenceAllocation} store={store} licenceAllocation={store.licenceAllocation}/>
                <Panel
                    id="licenceManager"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px',
                        overflow: 'unset',
                        maxWidth: '1400px',
                        margin: 'auto',
                        paddingTop: '30px',
                    }}
                >
                    <Select
                        label="Client"
                        onBlur={store.changeClient}
                        value={store.clientId}
                        clearable={false}
                        cssClass="defaultDropdown"
                        options={store.clients}
                    />
                    {!R.isNil(store.clientId) && (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    background: '#E8FCFA',
                                    border: '1px solid rgba(22, 204, 193, 0.2941176471)',
                                    padding: '10px',
                                }}
                            >
                                {store.tabIsActive('licenceGroups') && (
                                    <Button
                                        label="Create licence group"
                                        onClick={store.createLicenceGroup}
                                        variant="primary"
                                        cssClass="regular"
                                    />
                                )}
                                {store.tabIsActive('productLicences') && (
                                    <Button
                                        label="Create product licence"
                                        onClick={store.createlicenceAllocation}
                                        variant="primary"
                                        cssClass="regular"
                                    />
                                )}
                                {this.renderTabs()}
                            </div>
                            {store.tabIsActive('licenceGroups') && (
                                <DataTable
                                    store={store}
                                    inMemory
                                    dataSet={store.licenceGroups}
                                    columns={store.licenceGroupColumns}
                                />
                            )}
                            {store.tabIsActive('productLicences') && (
                                <DataTable
                                    store={store}
                                    inMemory
                                    dataSet={store.licenceAllocations}
                                    columns={store.licenceAllocationColumns}
                                />
                            )}
                        </>
                    )}
                </Panel>
            </>
        )
    }
}

export default LicenceManager
